import { INote, MasterdataAService, NotesService } from '../../../services';
import * as _ from "lodash";
import * as moment from "moment";

class NoteController {
    public notes: INote[];
    private note: INote;
    private tags: string[];
    private tag: string;
    private onUpdate: any;

    constructor(
        private MasterdataAService: MasterdataAService,
        private $state: ng.ui.IStateService,
        private NotesService: NotesService,
    ) {
        'ngInject';
    }

    $onInit = () => {
        this.MasterdataAService.getItems('NoteTags').then(res => {
            this.tags = res;
        });
    }

    focusInput() {
        document.getElementById('input').focus();
    }

    submitNote() {
        this.note.endDate = moment(this.note.endDate).format("YYYY-MM-DD HH:mm");
        this.onUpdate({ note: this.note });
    }

    endDateBeforeRender($dates) {
        const todaySinceMidnight = new Date();
        todaySinceMidnight.setUTCHours(0, 0, 0, 0);
    }
}

export const crmNoteComponent = {
    bindings: {
        note: '<',
        onUpdate: "&",
    },
    controller: NoteController,
    template: require('./note.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/notes/note.component.ts